import { render, staticRenderFns } from "./TableC.vue?vue&type=template&id=7825d2e2&scoped=true"
import script from "./TableC.vue?vue&type=script&lang=js"
export * from "./TableC.vue?vue&type=script&lang=js"
import style0 from "./TableC.vue?vue&type=style&index=0&id=7825d2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825d2e2",
  null
  
)

export default component.exports